module.exports = __webpack_public_path__ + "static/img/stamp_07.8a3ab00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_07.jpg
// module id = NrE8
// module chunks = 1